import React, { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { SQUAD_COLORS } from './templateConstants';
import { SQUAD_MIFID_PREVIEW_NOTICE } from './pageHeaderTokens';

/** Mockup notice box ≈ 76 % of layer width (3.67" / 4.82"). */
export const SQUAD_MIFID_NOTICE_WIDTH_PCT = '76%';

type Props = {
  active: boolean;
  noticeText: string;
  children: ReactNode;
  minHeight?: number | string;
};

const { baseFontSizePx, scale: noticeScale } = SQUAD_MIFID_PREVIEW_NOTICE;

/** Web preview — opaque white overlay, justified notice text centered in layer. */
export const SquadMifidOverlayLayer: FC<Props> = ({ active, noticeText, children, minHeight }) => (
  <Box sx={{ position: 'relative', width: '100%', minHeight }}>
    {children}
    {active ? (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
        }}
      >
        <Box
          sx={{
            width: `calc(${SQUAD_MIFID_NOTICE_WIDTH_PCT} / ${noticeScale})`,
            maxWidth: `calc(${SQUAD_MIFID_NOTICE_WIDTH_PCT} / ${noticeScale})`,
            transform: `scale(${noticeScale})`,
            transformOrigin: 'center center',
          }}
        >
          <Box
            component="p"
            sx={{
              width: '100%',
              m: 0,
              fontSize: `${baseFontSizePx}px`,
              lineHeight: 1.28,
              fontWeight: 400,
              color: SQUAD_COLORS.text,
              textAlign: 'justify',
              hyphens: 'auto',
              WebkitTextSizeAdjust: 'none',
              textSizeAdjust: 'none',
            }}
          >
            {noticeText}
          </Box>
        </Box>
      </Box>
    ) : null}
  </Box>
);
